


















import { Component, Vue } from "vue-property-decorator";

import { Campaign } from "@/models/definitions";

@Component
export default class NewCampaignCard extends Vue {}
